import { createSaga } from './saga-helpers';

import * as Api from '../api/automations-api';

const watchGetAutomations = createSaga({
    type: 'AUTOMATIONS_FETCH',
    fn: Api.fetchAutomations,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        automations: items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateAutomation = createSaga({
    type: 'AUTOMATION_CREATE',
    fn: Api.createAutomation,
    args: action => [action.payload.automation],
    successPayload: ({ _id, id }, action) => ({
        automationId: id || _id,
        fragment: action.payload.automation
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.automation
    })
});

const watchGetAutomation = createSaga({
    type: 'AUTOMATION_FETCH',
    fn: Api.fetchAutomation,
    args: action => [action.payload.automationId],
    successPayload: automation => ({ automation })
});

const watchUpdateAutomation = createSaga({
    type: 'AUTOMATION_UPDATE',
    fn: Api.updateAutomation,
    args: action => [action.payload.automationId, action.payload.automationProps],
    successPayload: automation => ({ automation })
});

const watchRemoveAutomation = createSaga({
    type: 'AUTOMATION_REMOVE',
    fn: Api.removeAutomation,
    args: action => [action.payload.automationId]
});

const sagas = [watchGetAutomations, watchCreateAutomation, watchGetAutomation, watchUpdateAutomation, watchRemoveAutomation];

export default sagas;
